import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../modules/ConfirmModal';
import Modal from '../../../modules/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (revisionTitle: string) => void /* 親の保存メソッド */;
};

/* 原稿編集画面 リビジョン保存用ダイアログ */
function RevisionSaveModal({ open, onClose, onSave }: Props) {
  const { t } = useTranslation();
  const [displayConfirm, setDisplayConfirm] = useState(false); // 確認ダイアログ
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ revision_title: string }>({
    defaultValues: {
      revision_title: String(''),
    },
  });

  const onSubmit = useCallback(() => {
    void handleSubmit((e) => {
      onSave(e.revision_title);
      onClose();
    })();
  }, [handleSubmit, onSave, onClose]);

  return (
    <Modal active={open} additionalClassName="popupfr600" displayCloseButton onClose={onClose}>
      <form onSubmit={onSubmit}>
        <div className="popupfr pt10 popupfr600">
          <div className="labip1">
            <div>
              <label htmlFor="revision_title">{t('改訂履歴タイトル')}</label>
              <input type="text" id="revision_title" {...register('revision_title')} />
            </div>
          </div>
          <div className="btnfr-all mb0" style={{ justifyContent: 'flex-end', marginTop: '18px' }}>
            <div>
              <span className="btn2 btnbg-g mr10">
                <span className="modal-close2" onClick={onClose}>
                  {t('キャンセル')}
                </span>
              </span>
              <span>
                <input
                  type="button"
                  value={t('履歴保存').toString()}
                  className="btn1 lsp1"
                  onClick={() => setDisplayConfirm(true)}
                />
              </span>
            </div>
          </div>
        </div>
      </form>
      {/* 履歴保存ダイアログ */}
      {displayConfirm && (
        <ConfirmModal
          onClickCancel={() => setDisplayConfirm(false)}
          onClickOk={() => {
            setDisplayConfirm(false);
            onSubmit();
          }}
        >
          {t('保存しますか?')}
        </ConfirmModal>
      )}
    </Modal>
  );
}
export default RevisionSaveModal;
